// import Layout from '@/layout'
import BasicLayout from '@/layout/BasicLayout.vue'

const mdcRouter = {
  path: '/mdc',
  component: BasicLayout,
  children: [
    {
      path: '/mdc/operation-statistics',
      component: () => import('../../views/mdc/operation-statistics/index')
    },
    {
      path: "/mdc/efficiency-statistics",
      component: () => import("@/views/mdc/index.vue"),
      children: [
        {
          path: '/mdc/realtime-status',
          component: () => import('@/views/mdc/realtime-status/index.vue')
        },
        {
          path: '/mdc/alarm-history',
          component: () => import('@/views/mdc/machine-alarm-history/index.vue')
        },
        {
          path: '/mdc/equipment-utilization-rate',
          component: () => import('@/views/mdc/equipment-utilization-rate/index.vue')
        },
        {
          path: "/mdc/time-analysis",
          component: () =>
            import("@/views/mdc/time-analysis/index"),
        },
        {
          path: "/mdc/station-comprehensive",
          component: () =>
            import("@/views/mdc/station-comprehensive/index"),
        },
        {
          path: "/mdc/status-record",
          component: () =>
            import("@/views/mdc/status-record/index"),
        },
        {
          path: "/mdc/productivity-analysis",
          component: () =>
            import("@/views/mdc/productivity-analysis/index"),
        },
        {
          path: "/mdc/alarm",
          component: () =>
            import("@/views/mdc/alarm/index"),
        },
        {
          path: "/mdc/process-parameters",
          component: () =>
            import("@/views/mdc/process-parameters/index"),
        },
        {
          path: "/mdc/device-history-data",
          component: () =>
            import("@/views/mdc/process-parameters/history.vue"),
        },
        {
          path: "/mdc/station-productivity",
          component: () =>
            import("@/views/mdc/station-productivity/index"),
        },
      ],
    },
    {
      path: '/mdc/setting',
      component: () => import('@/views/mdc/setting/setting.vue'),
      children: [
        {
          path: '/mdc/setting/conditionSetting',
          component: () => import('@/views/mdc/setting/components/conditionSetting.vue'),
        },
        {
          path: '/mdc/setting/analysisSetting',
          component: () => import('@/views/mdc/setting/components/analysisSetting.vue'),
        },
        {
          path: '/mdc/setting/equipmentStandardSetting',
          component: () => import('@/views/mdc/setting/components/equipmentStandardSetting.vue'),
        }
      ]
    }
  ]
}

export default mdcRouter
